import React, { useState } from "react";
import { TabPanel } from "../../Components/Tab/TabPanel";
import { IInventoryProps } from "./interface/Inventory.types";
import { TabsList } from "../../Components/Tab/Tab";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../Components/CustomButton";
import { ProductsTable } from "./Products/ProductsTable";
import { CategoriesTable } from "./Category/CategoriesTable";
import { CustomizationsTable } from "./Customization/CustomizationsTable";
import PageContainer from "../../Components/PageContainer/PageContainer";
import { UpsertCategoryDialog } from "./Category/dialogs/UpsertCategoryDialog";
import { defaultInventory, defaultCategory, defaultProductCustomization, fetchProductListWithArgsAsync } from "../../redux/inventory";
import { InventoryTable } from "./InventoryList/InventoryTable";
import { UpsertInventoryDialog } from "./InventoryList/dialogs/UpsertInventoryDialog";
import { CATEGORIES_ROUTE, CUSTOMIZATION_ROUTE, INVENTORY_ROUTE, PRODUCTS_ROUTE } from "./Inventory.constants";
import { ManageCustomizationDialog } from "./Customization/dialogs/ManageCustomizationDialog";
import { useOutletContext } from "../../providers";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { Download, DriveFolderUpload, GetApp, Upload } from "@mui/icons-material";
import { downloadMenuItemsAsCSVAsync, downloadMenuItemsAsExcelAsync, UpdateMenuItemsViaExcelAsync } from "./Products/Products.sevices";
import { SingleFileUploadButton } from "../../Components/FileUploads/FileUploadIcon/FileUploadIcon";
import LoadingDialog from "../../Components/Dialogs/LoadingDialog";
import { useAppDispatch } from "../../redux";
export const Inventory: React.FC<IInventoryProps> = (props) => {
  const { activeTab } = props;
  const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext()

  const [downloadLoading, setDownloadLoading] = useState(false)
  const [uploadLoading, setUploadLoading] = useState(false)
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const [tab, setTab] = React.useState(activeTab || 0);
  const [categoryDialogOpen, setCategoryDialogOpen] = React.useState<boolean>(false);
  const [inventoryListDialogOpen, setInventoryListDialogOpen] = React.useState<boolean>(false);
  const [customizationDialogOpen, setCustomizationDialogOpen] = React.useState<boolean>(false);

  const handleTabChange = (url: string) => { navigate(url) };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
    if (newValue === 0) handleTabChange(PRODUCTS_ROUTE);
    if (newValue === 1) handleTabChange(CATEGORIES_ROUTE);
    if (newValue === 2) handleTabChange(CUSTOMIZATION_ROUTE);
    if (newValue === 3) handleTabChange(INVENTORY_ROUTE);
  };

  const handleAddNew = () => {
    if (tab === 0) handleTabChange(PRODUCTS_ROUTE + "/manage");
    if (tab === 1) setCategoryDialogOpen(true);
    if (tab === 2) setCustomizationDialogOpen(true);
    if (tab === 3) setInventoryListDialogOpen(true);
  };

  const isLightMode = useTheme().palette.mode === "light";

  const handleDownloadExcelFileAsync = () => {
    if (!outlet_uuid) return alert("Outlet is not selected...!")
    setDownloadLoading(true);
    downloadMenuItemsAsCSVAsync(outlet_uuid).finally(() => setDownloadLoading(false));
  }

  const handleUploadExcelFileAsync = (file: File) => {
    if (!outlet_uuid) return alert("Outlet is not selected...!")
    setUploadLoading(true);
    UpdateMenuItemsViaExcelAsync(outlet_uuid, file).then(() => {
      dispatch(
        fetchProductListWithArgsAsync({
          outlet_uuid,
          page: 1,
          rowsPerPage: 15,
        }),
      );
    }).finally(() => setUploadLoading(false));
  }

  return (
    <PageContainer title="Inventory" description="inventory page" sx={{ paddingInline: 2 }} >
      <TabsList
        selectedTab={tab}
        tabData={[
          { tabLabel: "Products", tabLink: PRODUCTS_ROUTE },
          { tabLabel: "Categories", tabLink: CATEGORIES_ROUTE },
          { tabLabel: "Customizations", tabLink: CUSTOMIZATION_ROUTE },
          { tabLabel: "Inventory List", tabLink: INVENTORY_ROUTE },
        ]}
        onChange={handleChange}
      />
      <Box sx={{ display: 'flex', justifyContent: "flex-end", alignItems: "center", gap: 1, mt: 1 }}>
        {tab === 0 && (
          <>

            <SingleFileUploadButton type="BUTTON" title="Import Excel"
              accept=".csv,.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              disabled={uploadLoading}
              onChange={handleUploadExcelFileAsync} />
            <CustomButton
              variant="outlined"
              color="primary"
              sx={{
                minWidth: "80px !important",
                backgroundColor: isLightMode
                  ? "var(--secondary-color)"
                  : "var(--primary-color)",
                color: isLightMode
                  ? "var(--text-light-color)"
                  : "var(--text-dark-color)",
                border: isLightMode
                  ? "var(--border-light-color) 1px solid"
                  : "var(--border-dark-color) 1px solid",
                "&:hover": {
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--tertiary-color)",
                  opacity: isLightMode ? 0.85 : 1,
                  // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                },
              }}
              onClick={handleDownloadExcelFileAsync}
            >
              <GetApp sx={{ fontSize: 22 }} /> Export
            </CustomButton>
            {/* <Tooltip title="Download Excel">
              <IconButton disabled={downloadLoading} onClick={handleDownloadExcelFileAsync}></IconButton>
            </Tooltip> */}
          </>
        )
        }
        <CustomButton
          variant="outlined"
          color="primary"
          sx={{
            minWidth: "80px !important",
            backgroundColor: isLightMode
              ? "var(--secondary-color)"
              : "var(--primary-color)",
            color: isLightMode
              ? "var(--text-light-color)"
              : "var(--text-dark-color)",
            border: isLightMode
              ? "var(--border-light-color) 1px solid"
              : "var(--border-dark-color) 1px solid",
            "&:hover": {
              backgroundColor: isLightMode
                ? "var(--secondary-color)"
                : "var(--tertiary-color)",
              opacity: isLightMode ? 0.85 : 1,
              // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
              border: isLightMode
                ? "var(--border-light-color) 1px solid"
                : "var(--border-dark-color) 1px solid",
            },
          }}
          onClick={handleAddNew}
        >
          Add New
        </CustomButton>
      </Box>


      <TabPanel value={tab} index={0}>
        <ProductsTable />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <CategoriesTable />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <CustomizationsTable />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <InventoryTable />
      </TabPanel>

      {categoryDialogOpen && (
        <UpsertCategoryDialog
          open={true}
          category={{ ...defaultCategory, outlet_uuid, outlet_name }}
          onClose={() => setCategoryDialogOpen(false)}
        />
      )}

      {inventoryListDialogOpen && (
        <UpsertInventoryDialog
          open={true}
          inventory={defaultInventory}
          onClose={() => setInventoryListDialogOpen(false)}
        />
      )}
      {downloadLoading && <LoadingDialog open={downloadLoading} label="Downloading Menu Items...!" />}
      {uploadLoading && <LoadingDialog open={uploadLoading} label="Uploading Menu Items...!" />}
      {customizationDialogOpen && (
        <ManageCustomizationDialog
          open={true}
          customization={defaultProductCustomization}
          onClose={() => setCustomizationDialogOpen(false)}
        />
      )}
    </PageContainer>
  );
};
